"use client";
import React from 'react';
import classNames from 'classnames';
import { defineStyles } from '../hooks/defineStyles';
import { useStyles } from '../hooks/useStyles';

const styles = defineStyles("Loading", (theme: ThemeType) => ({
  spinner: {
    height: 10,
    maxWidth: 100,
    textAlign: "center",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  
    "& div": {
      width: 10,
      height: 10,
      backgroundColor: theme.palette.icon.loadingDots,
  
      borderRadius: "100%",
      display: "inline-block",
      "-webkit-animation": "sk-bouncedelay 1.4s infinite ease-in-out both",
      animation: "sk-bouncedelay 1.4s infinite ease-in-out both",
    },
  },
  whiteSpinner: {
    "& div": {
      backgroundColor: theme.palette.icon.loadingDotsAlternate,
    }
  },
  bounce1: {
    animationDelay: "-0.32s !important",
    marginRight: 5,
  },

  bounce2: {
    animationDelay: "-0.16s !important",
    marginRight: 5,
  },
  bounce3: {
    marginRight: 0,
  },
  
  "@keyframes sk-bouncedelay": {
    "0%, 80%, 100%": {
      transform: "scale(0)",
    },
    "40%": {
      transform: "scale(1.0)"
    }
  }
}));

const Loading = ({className, white}: {
  className?: string,
  white?: boolean
}) => {
  const classes = useStyles(styles);
  return (
    <div className={classNames(classes.spinner, className, {[classes.whiteSpinner]: white})}>
      <div className={classes.bounce1}></div>
      <div className={classes.bounce2}></div>
      <div className={classes.bounce3}></div>
    </div>
  );
};

export default Loading;
